module.exports = __webpack_public_path__ + "static/media/game-background-articulation.769db73d.jpg";